module.exports = __webpack_public_path__ + "img/tg.ebe1e65a.png";